export enum ExamType {
  ControleContinu = 'ControleContinu',
  Evaluation = 'Evaluation',
  Partiel = 'Partiel',
  Rattrapage = 'Rattrapage',
  Redoublement = 'Redoublement',
  RattrapageRedoublement = 'RattrapageRedoublement',
}
